import { useTranslation } from 'react-i18next';
import ReportsDashboard from '../ReportsDashboard';

const SalesDashboard = () => {
  const { t } = useTranslation();
  return <ReportsDashboard type="sales" pageTitle={`${t('dashboard')}: ${t('sales')}`} />;
};

export default SalesDashboard;
